import React, { createContext, useCallback, useContext, useState } from "react";

type FormValue = string | number | boolean;
type FormValues = Record<string, FormValue>;

interface FormContextType {
  values: FormValues;
  setValue: (id: string, value: FormValue) => void;
  setRadioGroupValue: (ids: string[], selectedId: string) => void;
  setInitValues: (values: FormValues) => void;
}

const FormContext = createContext<FormContextType | null>(null);

export const ResultingListProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [values, setValues] = useState<FormValues>({});

  const setValue = (id: string, value: FormValue) => {
    setValues((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const setRadioGroupValue = (ids: string[], selectedId: string) => {
    setValues((prev) => {
      const next = { ...prev };

      ids.forEach((id) => {
        next[id] = id === selectedId;
      });

      return next;
    });
  };

  const setInitValues = useCallback((initialValues: FormValues) => {
    setValues(initialValues);
  }, []);

  return (
    <FormContext.Provider
      value={{ values, setValue, setRadioGroupValue, setInitValues }}
    >
      {children}
    </FormContext.Provider>
  );
};

export function useResultingListForm(): FormContextType {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error(
      "useResultingListForm must be used inside ResultingListFormContextProvider",
    );
  }
  return context;
}
